import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { PolizaCredito } from '../../../models/finanzas/poliza-credito/poliza-credito.model';
import { PolizaCreditoListComponent } from './poliza-credito-list.component';
import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';
import { BankAccountService } from '../bancos/bankaccount.service';
import { UntypedFormControl } from '@angular/forms';
import { BankAccountBicsModel } from '../bancos/bankaccountbics.model';
import { map, Observable } from 'rxjs';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';

@Component({
    selector: 'convfact-poliza-credito-dialog-form',
    templateUrl: './poliza-credito-dialog-form.component.html',
    styleUrls: ['./poliza-credito.component.css'],
    standalone: false
})
export class PolizaCreditoDialogFormComponent implements OnInit {

  public polizaCredito: PolizaCredito = this.data.polizaCredito;

  public isEditMode: boolean = this.data.isEditMode;

  public saved: boolean = false;

  public ready: boolean = false;

  private changesAtModal: boolean = false;

  public bankAccountBics: BankAccountBicsModel[] = [];
  public bicsCtrl: UntypedFormControl;
  public filteredBics: Observable<BankAccountBicsModel[]>;
  public filteredBancos: BankAccountBicsModel[] = [];

  showApiKey = false;

  public invalidBanco = false;
  public invalidBic = false;
  public invalidBicMsg = 'Campo requerido';
  public invalidIban = false;
  public invalidLimite = false;

  constructor(
    public dialogRef: MatDialogRef<PolizaCreditoListComponent>,
    private cdr: ChangeDetectorRef,
    public polizaCreditoService: PolizaCreditoService,
    private bankAccountService: BankAccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private masterService: MasterService,
  ) { }

  public ngOnInit(): void {
    this.ready = false;

    if (this.isEditMode === false) {
      this.polizaCredito = {
        uid: '',
        accountingModelsNumber: '',
        banco: '',
        bic: '',
        iban: '',
        limite: 0,
        connected: false
      }
    }

    this.bankAccountService.getBics().then(response => {
      this.bankAccountBics = response;
      this.bicsCtrl = new UntypedFormControl();
      this.filteredBics = this.bicsCtrl.valueChanges
        .pipe(
          map(bankAccountBics => bankAccountBics && typeof bankAccountBics === 'object' ? bankAccountBics.bank : bankAccountBics),
          map(name => this.filterBics(name))
        );
      this.ready = true;
    });


  }

  public isBic(value: string) {
    return /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test(value.toUpperCase());
  }

  public onBancoInput(val: string): void {
    this.filteredBancos = val
      ? this.bankAccountBics.filter(b => b.bank.toLowerCase().includes(val.toLowerCase()))
      : this.bankAccountBics;
  }

  public onBancoSelected(bic: BankAccountBicsModel): void {
    this.polizaCredito.banco = bic.bank;
    this.polizaCredito.bic = bic.bic;
    this.bicsCtrl.setValue(bic.bic, { emitEvent: false });
  }

  public filterBics(val) {
    for (const bic of this.bankAccountBics) {
      if (bic.bank === val) {
        this.polizaCredito.bic = bic.bic;
      }
    }
    return val ? this.bankAccountBics.filter(s => s.bank.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.bankAccountBics;
  }

  public save(): void {
    this.invalidBanco = !this.polizaCredito.banco;
    this.invalidIban = !this.polizaCredito.iban;
    this.invalidLimite = this.polizaCredito.limite == null;

    const bicEmpty = !this.polizaCredito.bic;
    const bicInvalid = !bicEmpty && !this.isBic(this.polizaCredito.bic);
    this.invalidBic = bicEmpty || bicInvalid;
    this.invalidBicMsg = bicEmpty ? 'Campo requerido' : 'Formato BIC/SWIFT incorrecto';

    const noError = !this.invalidBanco && !this.invalidBic && !this.invalidIban && !this.invalidLimite;

    // Request
    if (noError) {
      this.changesAtModal = true;

      if (this.isEditMode === false) {
        this.polizaCreditoService.add(this.polizaCredito)
          .then(response => {
            this.saved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al añadir el elemento");
          });
      }
      if (this.isEditMode === true) {
        this.polizaCreditoService.edit(this.polizaCredito)
          .then(response => {
            this.saved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al actualizar el elemento");
          });
      }

    } else {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    }






  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close(this.changesAtModal);
  }
  public trackByIndex(i: number) { return i; }

}
